import { render, staticRenderFns } from "./payment-option-importer-page.vue?vue&type=template&id=1a2c6cf4&"
import script from "./payment-option-importer-page.vue?vue&type=script&lang=js&"
export * from "./payment-option-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports